<div class="cc-banner" [class.mobile]="topService.isMobile">
  <div class="cc-banner__text">
    <i class="_bg"></i>
    <h1>Credit Card<br/>Payment</h1>
    <p>Available on HUBX<br/>US Customers only</p>
    <button [routerLink]="['/user/credit_cards']"><span>+ Add New Card</span></button>
  </div>
</div>
